import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import RoleState, {IRoleList, RolePermissionList} from './states'
import _ from 'lodash'

const mutations: MutationTree<RoleState> = {
  [mutationType.GET_LISTS](
    state: RoleState,
    data: IRoleList,
  ): void {
    state.list = data
  },
  [mutationType.GET_ROLE_PERMISSION](
    state: RoleState,
    data: RolePermissionList[],
  ): void {
    state.rolePermissionList = data
  },
  [mutationType.GET_ROLE_USER](
    state: RoleState,
    data: any,
  ): void {
    state.roleUserList = data
  },
}

export default mutations
